import { z } from "zod";

const envSchema = z.object({
  VITE_BASE_API_URL: z.string().url(),
  VITE_WHIP_BASE_URL: z.string().url().optional(),
  VITE_HLS_BASE_URL: z.string().url().optional(),
  VITE_GOOGLE_CLIENT_ID: z.string().optional(),
  VITE_RECAPTCHA_SITE_KEY: z.string().optional(),
});

const parsed = envSchema.parse(import.meta.env);

/**
 * Strips a trailing "/api" path (with optional trailing slash) from a URL
 * without affecting the domain (e.g. "https://api.example.com/" stays intact).
 */
function stripApiPath(url: string): string {
  return url.replace(/\/api\/?$/, "").replace(/\/$/, "");
}

export const env = {
  ...parsed,
  // Default WHIP URL derives from API URL (same host, different path pattern)
  WHIP_BASE_URL:
    parsed.VITE_WHIP_BASE_URL || stripApiPath(parsed.VITE_BASE_API_URL),
  // Default HLS URL for stream playback
  HLS_BASE_URL: parsed.VITE_HLS_BASE_URL || "http://localhost:8888",
};
